import React, { Fragment, Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Form from 'react-bootstrap/lib/Form';
import SVG from 'react-inlinesvg';
import map from 'lodash.map';
import filter from 'lodash.filter';
import { RouteUrls } from '../../../configs/routeUrls';
import { Loader } from '../../Loader';
import { Button } from '../../Button';
import { ImageMimeType, SystemDistrict } from '../../../utils/enums';
import { dayFormat } from '../../../utils/date';
import { ChartBarWrapper } from '../../../components/ChartWrapper';
import { transformSVG } from '../../../utils/svg-extensions';

export const BudgetResultCard = ({
	isBudgetResultLoading,
	projectBudgetYearValue: budgetYearValue = 0,
	projectDescription: description = '',
	projectDateFrom: dateFrom = null,
	projectDateTo: dateTo = null,
	projectModeName: modeName = '',
	isOnlyOneOffice = true,
	projectOnlyForLegalAge: onlyForLegalAge = false,
	projectOfficeName: officeName = '',
	projectTitle: title = '',
	budgetVoteShowResultsByDistrict = false,
	budgetVoteShowResultsBySex = false,
	...props
}) => (
	<Fragment>
		{isBudgetResultLoading && <Loader loading={isBudgetResultLoading} />}
		{!isBudgetResultLoading && (
			<Fragment>
				<div id="content" className="container districts margin-top-40">
					<div className="consultations__item">
						<div className="consultations__header">
							<div className="consultations__title">{title}</div>

							<div className="consultations__icons">
								<Link to={RouteUrls.Budget.pages.prerequisiteFunc(budgetYearValue)} title="Do pobrania">
									<i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-download" />
								</Link>
								<Link to={RouteUrls.Budget.pages.scheduleFunc(budgetYearValue)} title="Harmonogram">
									<i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-calendar-alt" />
								</Link>
								<Link to={RouteUrls.Budget.pages.helpFunc(budgetYearValue)} title="Pomoc">
									<i
										className={`link link__icon link__icon-biggest link--primary-dark fas fa-question-circle`}
									/>
								</Link>
							</div>
						</div>
						<div className="consultations__body">
							<div className="consultation-item consultation-item-no-shadow consultation-item-no-border">
								<div className="consultation-item__body">
									<div className="consultation-item__desc margin-right-20">
										<div className="consultation-description__text">{description}</div>
									</div>
									<div>
										<div className="consultation-item__infos">
											<div className="consultation-item__info">
												<div className="consultation-item__info-label">Czas trwania od: </div>
												<div className="consultation-item__info-value">{`${dayFormat(
													dateFrom
												)}`}</div>
												<div className="consultation-item__info-label"> do: </div>
												<div className="consultation-item__info-value">{`${dayFormat(
													dateTo
												)}`}</div>
											</div>
											<div className="consultation-item__info">
												<div className="consultation-item__info-label">Tryb:</div>
												<div className="consultation-item__info-value">{modeName}</div>
											</div>
											<div className="consultation-item__info">
												<div className="consultation-item__info-label">
													Tylko dla pełnoletnich:
												</div>
												<div className="consultation-item__info-value">
													{onlyForLegalAge ? 'Tak' : 'Nie'}
												</div>
											</div>
											{!isOnlyOneOffice && (
												<div className="consultation-item__info">
													<div className="consultation-item__info-label">Jednostka: </div>
													<div className="consultation-item__info-value">{officeName}</div>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
							{map(props.districts, (district, districtIndex) => (
								<DistrictResult
									{...props}
									key={districtIndex}
									items={district.projects}
									name={district.districtName}
								/>
							))}
						</div>
					</div>
				</div>
				<div className="container statistics">
					<div className="statistic">
						<div className="statistic__title">Podsumowanie głosowania</div>
						<div className="statistic__items">
							<div className="statistic__item">
								<div>{<i className="fas fa-users statistic__icon" />}</div>
								<div className="statistic__text">Liczba głosów oddanych</div>
								<div className="statistic__value">{props.voteCount + props.incorrectVoteCount}</div>
							</div>
							<div className="statistic__item">
								<div>{<i className="far fa-check-circle statistic__icon" />}</div>
								<div className="statistic__text">Liczba głosów ważnych</div>
								<div className="statistic__value">{props.voteCount}</div>
							</div>
							<div className="statistic__item">
								<div>{<i className="far fa-times-circle statistic__icon" />}</div>
								<div className="statistic__text">Liczba głosów nieważnych</div>
								<div className="statistic__value">{props.incorrectVoteCount}</div>
							</div>
						</div>
					</div>
					{budgetVoteShowResultsBySex && (
						<div className="statistic">
							<div className="statistic__title">Liczba głosów ważnych w podziale na płeć</div>
							<div className="statistic__items">
								<div className="statistic__item">
									<div>
										<i className="fas fa-female statistic__icon" />
									</div>
									<div className="statistic__value">{props.femaleVoteCount}</div>
								</div>
								<div className="statistic__item">
									<div>
										<i className="fas fa-male statistic__icon" />
									</div>
									<div className="statistic__value">{props.maleVoteCount}</div>
								</div>
							</div>
							<div className="statistic__text">
								Liczba głosów nieważnych - {props.incorrectVoteCount} (w tym: mężczyźni -{' '}
								{props.incorrectMaleVoteCount}, kobiety - {props.incorrectFemaleVoteCount})
							</div>
						</div>
					)}
					{budgetVoteShowResultsByDistrict && (
						<div className="statistic" style={{marginBottom: 0}}>
							<div className="statistic__title">Frekwencja w podziale na obszary</div>
							<div className="statistic__subtitle">(z wyłączeniem głosów nieważnych)</div>
							<div className="statistic__items">
								<div className="statistic__chart">
									<Chart
										summaries={map(
											filter(
												props.userVoteCountByDistrict,
												(vote) => vote.districtName && vote.districtId !== SystemDistrict
											),
											(vote) => ({
												x: vote.districtName,
												y: vote.voteCount
											})
										)}
									/>
								</div>
							</div>
						</div>
					)}
					<div className="buttons padding-top-20 padding-bottom-20">
						<Button variant="danger" onClick={props.onCancel}>
							Powrót
						</Button>
					</div>
				</div>
			</Fragment>
		)}
	</Fragment>
);

class DistrictResult extends Component {
	constructor(props) {
		super(props);

		this.state = {
			opened: true
		};

		this.toggleOpen = (e) => {
			e.preventDefault();
			this.setState({
				opened: !this.state.opened
			});
		};
	}

	render() {
		const { name, items } = this.props;
		const { opened } = this.state;

		return (
			<Fragment>
				<div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
					<div className="consultations__header">
						<div className="consultations__title consultations__title--center">{name}</div>

						<div className="consultations__icons">
							<div
								className="consultations__switch consultations__switch--primary-dark"
								onClick={this.toggleOpen}
							>
								{opened ? 'Zwiń' : 'Rozwiń'}
								{<i className={`consultations__icon fas fa-angle-${opened ? 'up' : 'down'}`} />}
							</div>
						</div>
					</div>
					{opened && (
						<div className="consultations__body">
							{
								// map(items, (category, categoryIndex) => (
								// <CategoryResult
								// 	{...this.props}
								// 	key={categoryIndex}
								// 	index={categoryIndex}
								// 	items={category.projects}
								// 	name={category.categoryName}
								// />
								// ))
							}

							{map(items, (project, projectIndex) => (
								<ProjectResult {...this.props} index={projectIndex} key={projectIndex} {...project} />
							))}
						</div>
					)}
				</div>
			</Fragment>
		);
	}
}

const CategoryResult = ({ ...props }) => (
	<Fragment>
		<div className=" margin-left-30">
			<div className="consultation__info title title--sub title--bottom-30 title--top-30">
				<div className="title__label title__label--primary-dark">Kategoria: </div>
				<div className="title__value">{props.name}&nbsp;</div>
			</div>
		</div>
		{map(props.items, (project, projectIndex) => (
			<ProjectResult {...props} index={projectIndex} key={projectIndex} {...project} />
		))}
	</Fragment>
);

class ProjectResult extends Component {
	render() {
		const {
			index,
			projectTaskName,
			projectTaskId,
			projectTaskPoints,
			projectTaskDescription,
			projectTaskThumbMainImage,
			projectTaskThumbMainImageContentType = ImageMimeType.SVG,
			projectTaskCost,
			projectTaskCategory
		} = this.props;

		const substringDescription = projectTaskDescription ? projectTaskDescription.substring(0, 270) : '';

		return (
			<Fragment>
				<div className="consultation-item consultation-item-no-shadow consultation-item-no-border">
					<div className="consultation-item__header text text--font-size-25 text--weight-700 text--bottom-20">
						Miejsce {index + 1}
					</div>
					<div className="consultation-item__header">{projectTaskName}</div>
					<div
						className={`consultation-item__body consultation-item__body--center consultation-item__body--short`}
					>
						<div className={`consultation-item__desc margin-right-20 consultation-item__desc--short`}>
							<div className="consultation-description__text">
								{substringDescription}

								<NavLink
									to={`${RouteUrls.Budget.projectTasks.preview}/${projectTaskId}`}
									className="link"
									target="_blank"
									title="Szczegóły projektu"
								>
									&nbsp;więcej
								</NavLink>
							</div>
						</div>
						<div className="consultation-item__question">
							<Form.Row>
								<Form.Group>
									<div className="field field--question budget-result">
										<Form.Control
											disabled={true}
											value={`${projectTaskPoints} pkt`}
											className="field__input field__input--center"
											aria-label={`Liczba punktów dla projektu ${projectTaskName}`}
										/>
									</div>
								</Form.Group>
							</Form.Row>
						</div>
						<div className="consultation-item__image">
							{projectTaskThumbMainImage && (
								<figure className="thumbnail">
									{projectTaskThumbMainImageContentType !== ImageMimeType.SVG && (
										<div className="svg-container">
											<img
												className="thumbnail__content"
												src={`data:image/jpeg;base64, ${projectTaskThumbMainImage}`}
												alt={`Główne zdjęcie projektu ${projectTaskName}`}
											/>
										</div>
									)}
									{projectTaskThumbMainImageContentType === ImageMimeType.SVG && (
										<div className="svg-container">
											<SVG
												src={transformSVG(
													projectTaskThumbMainImage,
													`svg-project-${projectTaskId}`,
													`Główne zdjęcie projektu ${projectTaskName}`
												)}
											/>
										</div>
									)}
								</figure>
							)}
						</div>
					</div>

					<div className="consultation__info text text--font-size-16 text--top-10">
						<div className="title__label title__label--primary-dark">Kategoria: </div>
						<div className="title__value">{projectTaskCategory}&nbsp;</div>
					</div>
					<div className="consultation-item__header text text--font-size-16 text--weight-700 text--top-10 text--bottom-40">
						Szacowany koszt:{' '}
						{projectTaskCost.toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' })}
					</div>
				</div>
			</Fragment>
		);
	}
}

const Chart = ({ ...props }) => (
	// {
	// 	< ResponsiveBar
	// 	data={props.data}
	// 	keys={props.keys}
	// 	indexBy={props.indexBy}
	// 	margin={{
	// 		top: 50,
	// 		right: 130,
	// 		bottom: 50,
	// 		left: 60
	// 	}}
	// 	padding={0.3}
	// 	innerPadding={3}
	// 	groupMode="grouped"
	// 	colors={[ '#264796', '#E53A24', '#df9840', '#108bf0', '#d14221', '#EF7F1A' ]}
	// 	colorBy="id"
	// 	borderColor="inherit:darker(1.6)"
	// 	axisTop={null}
	// 	axisRight={null}
	// 	axisBottom={{
	// 		tickSize: 5,
	// 		tickPadding: 5,
	// 		tickRotation: 0,
	// 		legend: 'obszar',
	// 		legendPosition: 'middle',
	// 		legendOffset: 32
	// 	}}
	// 	axisLeft={{
	// 		tickSize: 5,
	// 		tickPadding: 5,
	// 		tickRotation: 0,
	// 		legend: 'liczba głosów',
	// 		legendPosition: 'middle',
	// 		legendOffset: -40
	// 	}}
	// 	labelSkipWidth={12}
	// 	labelSkipHeight={12}
	// 	labelTextColor="inherit:darker(1.6)"
	// 	animate={true}
	// 	motionStiffness={90}
	// 	motionDamping={15}
	// 		/>
	// }
	<ChartBarWrapper summaries={props.summaries} />
);

BudgetResultCard.defaultProps = {
	isBudgetResultLoading: false
};
